// extracted by css-extract-rspack-plugin
export default {"cls1":"PullToRefresh-cls1_fky","cls2":"PullToRefresh-cls2_sdi PullToRefresh-cls1_fky"};